module.exports = __webpack_public_path__ + "img/map_1791449275183_51700.2d03f30c.gif";